/* Mushy · Sticky-Kaufleiste
   ------------------------------------------------------------------
   Sichtbar, sobald der CTA im Hero aus dem Bild gescrollt ist. Die Wahl
   in der Liste klickt die passende Bundle-Pill an: dann laeuft der Wechsel
   ueber mu-bundle-switch, mit Vorladen und History, und Leiste und Pills
   koennen nicht auseinanderlaufen.
*/
if (!customElements.get('mu-sticky-buy')) {
  customElements.define(
    'mu-sticky-buy',
    class MuStickyBuy extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.mu-sticky__panel');
        this.toggle = this.querySelector('.mu-sticky__toggle');
        this.cta = this.querySelector('.mu-sticky__cta');

        // Beim Bundle-Wechsel wird die Section neu gezeichnet. War die Liste
        // offen, bleibt sie offen — sonst klappt sie einem unter der Hand zu.
        if (MuStickyBuy.open) this.setOpen(true);

        if (this.toggle) {
          this.toggle.addEventListener('click', () => this.setOpen(!MuStickyBuy.open));
        }

        // Staffel-Modus: die Zeile klickt die passende Pill in mu-bundle-panes.
        this.querySelectorAll('[data-pane-row]').forEach((row) => {
          row.addEventListener('click', () => {
            const pill = document.querySelector(
              'mu-bundle-panes [data-pane-pill="' + row.dataset.paneRow + '"]'
            );
            if (pill) pill.click();
            this.setOpen(false);
          });
        });

        this.querySelectorAll('[data-go]').forEach((row) => {
          row.addEventListener('click', () => {
            if (row.classList.contains('is-active')) {
              this.setOpen(false);
              return;
            }
            const pill = document.querySelector(
              'mu-bundle-switch a.mu-pill--bundle[href="' + row.dataset.go + '"]'
            );
            if (pill) pill.click();
            else window.location.href = row.dataset.go;
          });
        });

        if (this.cta) {
          this.cta.addEventListener('click', () => {
            const form = document.getElementById(this.dataset.form);
            if (!form) return;
            this.setOpen(false);
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.submit();
          });
        }

        this.watch();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      setOpen(state) {
        MuStickyBuy.open = state;
        if (this.panel) this.panel.hidden = !state;
        if (this.toggle) this.toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
      }

      /* Anker ist der CTA im Hero. Solange er im Bild ist, braucht es die
         Leiste nicht. Ohne IntersectionObserver bleibt sie einfach weg —
         besser als eine Leiste, die immer im Weg steht. */
      watch() {
        const anchor = document.querySelector('.mu-buybox #mu-product-hero-form .mu-cta')
          || document.querySelector('#mu-buy .mu-cta');
        if (!anchor || !('IntersectionObserver' in window)) return;

        this.io = new IntersectionObserver(
          (entries) => {
            const gone = !entries[0].isIntersecting;
            this.hidden = false;
            this.classList.toggle('is-shown', gone);
            if (!gone) this.setOpen(false);
          },
          { rootMargin: '0px 0px -10px 0px' }
        );
        this.io.observe(anchor);
      }
    }
  );
}
